@if (scansDownloadLeft) {
  <div class="scans-load-wrapper">
    <p>
      {{
        'dental.order.impression_delivery_method.scans_download_in_progress.label' | translate: { scansDownloadLeft }
      }}
    </p>
    <i class="fas fa-spinner-third"></i>
  </div>
}
